var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.254,
    height: 25.256,
    viewBox: "0 0 25.254 25.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3568",
    "data-name": "Group 3568",
    transform: "translate(-791.006 4819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M3.347,26.333a1.2,1.2,0,0,0,1.494,1.494l4.244-1.275a.616.616,0,0,1,.473.06,12.511,12.511,0,0,0,6.051,1.56,12.852,12.852,0,0,0,1.551-.095,12.627,12.627,0,1,0-12.6-6.461.612.612,0,0,1,.06.472Zm2.265-5.295a11.429,11.429,0,1,1,4.525,4.524,1.85,1.85,0,0,0-.889-.232,1.758,1.758,0,0,0-.507.074L4.5,26.678,5.77,22.435A1.8,1.8,0,0,0,5.612,21.039Z",
    transform: "translate(788 -4821.918)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M19.8,29.6h3.6a1.8,1.8,0,1,0,0-3.6V23.5a1.8,1.8,0,0,0-.6-3.5H20.4a1.8,1.8,0,0,0-.6,3.5V26a1.8,1.8,0,0,0,0,3.6Zm0-2.4h.6a.6.6,0,0,0,.6-.6V23a.6.6,0,0,0-.6-.6.6.6,0,1,1,0-1.2h2.4a.6.6,0,1,1,0,1.2.6.6,0,0,0-.6.6v3.6a.6.6,0,0,0,.6.6h.6a.6.6,0,0,1,0,1.2H19.8a.6.6,0,0,1,0-1.2Z",
    transform: "translate(782.005 -4828.748)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M22.4,15.8A2.4,2.4,0,1,0,20,13.4,2.4,2.4,0,0,0,22.4,15.8Zm0-3.6a1.2,1.2,0,1,1-1.2,1.2A1.2,1.2,0,0,1,22.4,12.2Z",
    transform: "translate(781.205 -4825.15)",
    fill: "#fafafa"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/Icon_Info.00a5274e91ab35fcb2463af4ee036752.svg";
export { ForwardRef as ReactComponent };